import { theme } from 'aimo-ui';
import { useEffect, useState } from 'react';
import { Dimensions } from 'react-native';
import Animated, {
  Easing,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';
import styled from 'styled-components/native';

export const SkeletonWrapper = styled.View<{ width: number }>`
  width: ${({ width }) => width}px;
`;

const SkeletonRow = styled.View<SkeletonLoaderProps>`
  height: ${({ height }) => height}px;
  background-color: ${theme.colors.gray200};
  border-radius: 8px;
  overflow: hidden;
  opacity: 0.2;
`;

const screenWidth = Dimensions.get('window').width;

const ShimmerGradient = styled(Animated.View)`
  position: absolute;
  background-color: ${theme.colors.white};
  width: 10%;
  height: 100%;
  opacity: 0.2;
  border-radius: 8px;
`;

type SkeletonLoaderProps = {
  height?: number;
  accessibilityLabel?: string;
};

const SkeletonLoaderRow = ({
  height = 30,
  accessibilityLabel,
}: SkeletonLoaderProps) => {
  const shimmerTranslateX = useSharedValue(-50);
  const [layoutWidth, setLayoutWidth] = useState(screenWidth);

  useEffect(() => {
    shimmerTranslateX.value = withRepeat(
      withTiming(100, {
        duration: 1500,
        easing: Easing.bezier(0.4, 0, 0.6, 1),
      }),
      -1,
      false
    );
  }, [shimmerTranslateX]);

  const shimmerStyle = useAnimatedStyle(() => {
    return {
      transform: [
        {
          translateX: interpolate(
            shimmerTranslateX.value,
            [0, 100],
            [0, layoutWidth]
          ),
        },
      ],
    };
  });

  return (
    <SkeletonRow
      accessibilityLabel={accessibilityLabel}
      accessibilityState={{ busy: true }}
      onLayout={(e) => {
        setLayoutWidth(e.nativeEvent.layout.width);
      }}
      style={{ height }}>
      <ShimmerGradient style={shimmerStyle} />
    </SkeletonRow>
  );
};

export default SkeletonLoaderRow;
